import actionTypes from './actionTypes';

const INIT_STATE = {
  getRegionsListLoading: false,
  getRegionsListFailed: false,
  getRegionsListError: false,
  getRegionsListMessage: '',
  regionsList: [],
  regionsListTotalRecords: 0,

  getRegionsNamesLoading: false,
  getRegionsNamesFailed: false,
  getRegionsNamesError: false,
  getRegionsNamesMessage: '',
  regionsNames: [],

  getRegionByIdLoading: false,
  getRegionByIdFailed: false,
  getRegionByIdError: false,
  getRegionByIdMessage: '',
  region: [],

  updateRegionLoading: false,
  updateRegionFailed: false,
  updateRegionError: false,
  updateRegionMessage: '',

  addNewRegionLoading: false,
  addNewRegionFailed: false,
  addNewRegionError: false,
  addNewRegionMessage: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_REGIONS_LIST_LOADING: {
      return {
        ...state,
        getRegionsListLoading: true,
        getRegionsListFailed: false,
        getRegionsListError: false,
        getRegionsListMessage: '',
        regionsList: [],
        regionsListTotalRecords: 0,
      };
    }
    case actionTypes.GET_REGIONS_LIST_SUCCESS: {
      return {
        ...state,
        getRegionsListLoading: false,
        getRegionsListFailed: false,
        getRegionsListError: false,
        getRegionsListMessage: '',
        regionsList: action.payload.regions,
        regionsListTotalRecords: action.payload.totalRecords,
      };
    }
    case actionTypes.GET_REGIONS_LIST_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getRegionsListLoading: false,
        getRegionsListFailed: true,
        getRegionsListError: false,
        getRegionsListMessage: message,
        regionsList: [],
        regionsListTotalRecords: 0,
      };
    }
    case actionTypes.GET_REGIONS_LIST_REJECT: {
      return {
        ...state,
        getRegionsListLoading: false,
        getRegionsListFailed: false,
        getRegionsListError: true,
        getRegionsListMessage: '',
        regionsList: [],
        regionsListTotalRecords: 0,
      };
    }

    case actionTypes.GET_REGIONS_NAMES_LOADING: {
      return {
        ...state,
        getRegionsNamesLoading: true,
        getRegionsNamesFailed: false,
        getRegionsNamesError: false,
        getRegionsNamesMessage: '',
        regionsNames: [],
      };
    }
    case actionTypes.GET_REGIONS_NAMES_SUCCESS: {
      return {
        ...state,
        getRegionsNamesLoading: false,
        getRegionsNamesFailed: false,
        getRegionsNamesError: false,
        getRegionsNamesMessage: '',
        regionsNames: action.payload.regions,
      };
    }
    case actionTypes.GET_REGIONS_NAMES_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getRegionsNamesLoading: false,
        getRegionsNamesFailed: true,
        getRegionsNamesError: false,
        getRegionsNamesMessage: message,
        regionsNames: [],
      };
    }
    case actionTypes.GET_REGIONS_NAMES_REJECT: {
      return {
        ...state,
        getRegionsNamesLoading: false,
        getRegionsNamesFailed: false,
        getRegionsNamesError: true,
        getRegionsNamesMessage: '',
        regionsNames: [],
      };
    }

    case actionTypes.GET_REGION_BY_ID_LOADING: {
      return {
        ...state,
        getRegionByIdLoading: true,
        getRegionByIdFailed: false,
        getRegionByIdError: false,
        getRegionByIdMessage: '',
        region: [],
      };
    }
    case actionTypes.GET_REGION_BY_ID_SUCCESS: {
      return {
        ...state,
        getRegionByIdLoading: false,
        getRegionByIdFailed: false,
        getRegionByIdError: false,
        getRegionByIdMessage: '',
        region: action.payload,
      };
    }
    case actionTypes.GET_REGION_BY_ID_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getRegionByIdLoading: false,
        getRegionByIdFailed: true,
        getRegionByIdError: false,
        getRegionByIdMessage: message,
        region: [],
      };
    }
    case actionTypes.GET_REGION_BY_ID_REJECT: {
      return {
        ...state,
        getRegionByIdLoading: false,
        getRegionByIdFailed: false,
        getRegionByIdError: true,
        getRegionByIdMessage: '',
        region: [],
      };
    }

    case actionTypes.UPDATE_REGION_LOADING: {
      return {
        ...state,
        updateRegionLoading: true,
        updateRegionFailed: false,
        updateRegionError: false,
        updateRegionMessage: '',
      };
    }
    case actionTypes.UPDATE_REGION_SUCCESS: {
      return {
        ...state,
        updateRegionLoading: false,
        updateRegionFailed: false,
        updateRegionError: false,
        updateRegionMessage: '',
        regionsList: action.payload,
      };
    }
    case actionTypes.UPDATE_REGION_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        updateRegionLoading: false,
        updateRegionFailed: true,
        updateRegionError: false,
        updateRegionMessage: message,
      };
    }
    case actionTypes.UPDATE_REGION_REJECT: {
      return {
        ...state,
        updateRegionLoading: false,
        updateRegionFailed: false,
        updateRegionError: true,
        updateRegionMessage: '',
      };
    }

    case actionTypes.ADD_NEW_REGION_LOADING: {
      return {
        ...state,
        addNewRegionLoading: true,
        addNewRegionFailed: false,
        addNewRegionError: false,
        addNewRegionMessage: '',
      };
    }
    case actionTypes.ADD_NEW_REGION_SUCCESS: {
      return {
        ...state,
        addNewRegionLoading: false,
        addNewRegionFailed: false,
        addNewRegionError: false,
        addNewRegionMessage: '',
      };
    }
    case actionTypes.ADD_NEW_REGION_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        addNewRegionLoading: false,
        addNewRegionFailed: true,
        addNewRegionError: false,
        addNewRegionMessage: message,
      };
    }
    case actionTypes.ADD_NEW_REGION_REJECT: {
      return {
        ...state,
        addNewRegionLoading: false,
        addNewRegionFailed: false,
        addNewRegionError: true,
        addNewRegionMessage: '',
      };
    }

    default: {
      return { ...state };
    }
  }
};
